/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RefundResponse
 */
export interface RefundResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RefundResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'refundId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof RefundResponse
     */
    'status'?: string;
}

